import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapFlagIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.4 6.16H19.42V16.22H8.88L9.6 14.14H6.26V20.38H4.58V4.08H15.1L14.4 6.16ZM6.26 12.46H10.22L12.76 5.78H6.26V12.46ZM17.74 14.54V7.84H13.78L11.24 14.54H17.74Z" />
    </SvgIcon>
  );
});
